import { NoValue as EmptyCell } from 'module/ui/components/atoms/no-value/empty-cell';
import { Rate } from 'module/ui/components/atoms/rate';
import { memoize } from 'lodash';
import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const csatRender = memoize((csatValue: number) => {
  if (csatValue) {
    return (
      <Flex>
        <Rate count={1} defaultValue={1} disabled />
        <span className="ant-rate-text">{csatValue}</span>
      </Flex>
    );
  }

  return <EmptyCell />;
});

export const CsatRatingRenderer = ({ value }: { value: number }) => {
  return csatRender(value);
};
